import React, { useContext, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppMenu from './AppMenu';
import { classNames } from 'primereact/utils';
import AuthContext from '../context/authContext';
import { Avatar } from 'primereact/avatar';

import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import { ChangePasswordValidate } from '../config/Validate';
import { getAllDetails, postAllData } from '../service/ProductService';
import { CHANGE_PASSWORD, SEARCH } from '../config/ApiConstant';
//Buffer Storage
import { Buffer } from 'buffer';
import { setAdminProfile } from '../appconfig/AppHelper';

const AppTopbar = (props: any) => {
    const navigate = useNavigate();

    const { logout }: any = useContext(AuthContext);
    const toast = useRef<any>(null);

    const [chnagePasswordDialog, setChangePasswordDialog] = useState<boolean>(false);
    const [buttonLoader, setSaveButtonLoader] = useState<boolean>(false);
    const [passwordData, setPasswordData] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [search, setSearch] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const fullName = localStorage.getItem('name');

    const location = useLocation();

    // handle Change
    const _onHandleChange = (e: any, name: string) => {
        const val = (e.target && e.target.value) || '';
        setPasswordData({ ...passwordData, [name]: val });
    };

    const closePasswordChnageDialog = () => {
        setChangePasswordDialog(false);
        setPasswordData({});
    };

    const onSubmit = async () => {
        try {
            const { errors, isError } = ChangePasswordValidate(passwordData);
            setErrors(errors);
            if (!isError) {
                setSaveButtonLoader(true);
                const requestData = {
                    old_password: Buffer.from(passwordData?.current_password).toString('base64'),
                    password: Buffer.from(passwordData?.new_password).toString('base64'),
                    confirm_password: Buffer.from(passwordData?.confirm_password).toString('base64')
                };

                const response = await postAllData(CHANGE_PASSWORD, requestData);
                if (response) {
                    setSaveButtonLoader(false);
                    setChangePasswordDialog(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    logout();
                }
            }
        } catch (error: any) {
            if (error.response) {
                setSaveButtonLoader(false);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: error.response.data.error });
            }
        }
    };
    const onSearch = async (e: any) => {
        e.preventDefault();
        try {
            if (search) {
                setLoading(true);
                const response = await getAllDetails(SEARCH + '?search=' + search);
                let srNo = response?.SrNo;
                if (response) {
                    setSearch('');
                    setLoading(false);
                    handleView(srNo);
                }
            }
        } catch (error: any) {
            if (error.response) {
                setSearch('');
                setLoading(false);

                toast.current?.show({
                    severity: 'error',
                    summary: 'Alert',
                    detail: error.response.data.data
                });
            }
        }
    };

    // Handle View Data
    const handleView = (fileNo: any) => {
        const fileNum = window.btoa(fileNo);
        const Splitdata = location.pathname.split('/');
        const routeName = Splitdata[Splitdata.length - 2];
        if (routeName === 'applicationViewForm') {
            window.location.href = `/app/application/applicationViewForm/${fileNum}`;
        } else {
            navigate(`/app/application/applicationViewForm/${fileNum}`);
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="layout-topbar">
                <div className="layout-topbar-left">
                    <h3 className="mb-0 product-name">Gujarat State Pharmacy Council</h3>
                    <form onSubmit={(e) => onSearch(e)}>
                        <span className="block mt-2 md:mt-0 p-input-icon-left input-icon-d">
                            <InputText type="text" value={search} placeholder="Search by File No. / Reg No." className="global-search" onChange={(e) => setSearch(e.target.value)} />
                            <i className="pi pi-search" />
                        </span>
                    </form>
                </div>

                <div className="layout-topbar-right">
                    <ul className="layout-topbar-right-items">
                        <li id="profile" className={classNames('profile-item', { 'active-topmenuitem': props.topbarMenuActive })}>
                            <span className="mr-1" onClick={props.onTopbarItemClick} style={{ color: '#fff' }}>
                                {fullName}
                            </span>

                            <button className="p-link " onClick={props.onTopbarItemClick}>
                                <Avatar image={setAdminProfile(fullName)} shape="circle" />
                                {/* <Avatar icon="pi pi-user" shape="circle" style={{ backgroundColor: '#fff' }} /> */}
                            </button>

                            <ul className="fadeInDown">
                                {/* <li role="menuitem">
                                    <button
                                        className="p-link"
                                        onClick={() => {
                                            setChangePasswordDialog(true);
                                        }}
                                    >
                                        <i className="pi pi pi-user"></i>
                                        <span>Change Password</span>
                                    </button>
                                </li> */}
                                <li role="menuitem">
                                    <button className="p-link" onClick={logout}>
                                        <i className="pi pi-power-off"></i>
                                        <span>Logout</span>
                                    </button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            <Dialog
                visible={chnagePasswordDialog}
                className="p-fluid"
                style={{ width: '550px' }}
                header="Change Password"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={() => closePasswordChnageDialog()} />
                        <Button label="Change Password" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmit()} loading={buttonLoader} />
                    </>
                }
                onHide={() => closePasswordChnageDialog()}
            >
                <div className="formgrid ">
                    <div className="field">
                        <label htmlFor="name">
                            Current Password <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Password
                            value={!window.cn(passwordData?.current_password) ? passwordData?.current_password : ''}
                            name="current_password"
                            autoComplete="off"
                            placeholder="Current Password"
                            onChange={(e) => _onHandleChange(e, 'current_password')}
                            feedback={false}
                            toggleMask={false}
                            className={errors['current_password'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt d-flex">{errors['current_password']}</small>
                    </div>
                    <div className="field">
                        <label htmlFor="name">
                            New Password <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Password
                            value={!window.cn(passwordData?.new_password) ? passwordData?.new_password : ''}
                            name="new_password"
                            placeholder="New Password"
                            onChange={(e) => _onHandleChange(e, 'new_password')}
                            feedback={false}
                            toggleMask={false}
                            className={errors['new_password'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt d-flex">{errors['new_password']}</small>
                    </div>
                    <div className="field">
                        <label htmlFor="name">
                            Confirm Password <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Password
                            value={!window.cn(passwordData?.confirm_password) ? passwordData?.confirm_password : ''}
                            name="confirm_password"
                            placeholder="Confirm Password"
                            onChange={(e) => _onHandleChange(e, 'confirm_password')}
                            feedback={false}
                            toggleMask={false}
                            className={errors['confirm_password'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt d-flex">{errors['confirm_password']}</small>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default AppTopbar;
